import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {LoanDetailsService} from '../service/loan-details.service';
import {RejectloanComponent} from '../rejectloan/rejectloan.component';
import {SubventionService} from '../service/subvention.service';
import {SubventionPreferenceService} from '../service/subvention-preference.service';
import {ChannelPartnerService} from '../service/channel-partner.service';
import {SubventionUtil} from '../utils/subvention-util';
import {MathUtil} from '../utils/math.util';
import {HasBreadcrumb} from '../borrow/borrower-dashboard/breadcrumbs/breadcrumb';
import {HttpClient} from '@angular/common/http';
import {EmailVerificationModalComponent} from '../email-verification-modal/email-verification-modal.component';
import {ChannelPartner, ChannelPartnerGroupType} from '../model/channel-partner.model';


@Component({
    selector: 'app-loansanction',
    templateUrl: './loan-sanction.component.html',
    styleUrls: ['./loan-sanction.component.css', '../../assets/styles/finzy-styles.scss'],
    providers: [ApiServiceService, LoanDetailsService]
})
export class LoanSanctionComponent implements OnInit, HasBreadcrumb {
    loanInfoResult: any;
    resendEmailVerificationResult: any;
    name: string;
    photo: string;
    loanStatus: string;
    ifNotSanctioned: boolean;
    ifSanctioned: boolean;
    ifAccepted: boolean;
    ifRejected: boolean;
    loanAmt: number;
    emi_amount: number;
    roi: number;
    loan_tenure: number;
    errorEmail = false;
    showAcceptBtn = true;
    resendEmail = false;
    offerTime: any;
    email: string;
    public fractionSize: any;
    loader = false;
    acceptOfferBtn = true;
    finzyDomain = true;
    otherDomain = false;
    hideRejectBtn = true;

    isReferralSchemeEnabled: boolean;
    partnerName: string;
    channelPartner: ChannelPartner;
    private loanId: string;
    public readonly userId = this.storageService.getItem(Keys.PROFILE_ID);
    isEmailVerified = false;
    hideEmiAmount = false;
    hideLoanTenure = false;

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService, private storageService: StorageService,
                public dialog: MatDialog, public loanDetailsService: LoanDetailsService, private subventionService: SubventionService,
                private subventionPreferenceService: SubventionPreferenceService, private channelPartnerService: ChannelPartnerService,
                private subventionUtil: SubventionUtil, private activatedRoute: ActivatedRoute) {
        activatedRoute.data.subscribe(({loanId}: { loanId: string }) => {
            this.storageService.saveItem(Keys.LOAN_ID, loanId);
            return this.loanId = loanId;
        });
    }

    openDialog() {
        const dialogRef = this.dialog.open(RejectloanComponent, {height: '300px', width: '400px'});

        dialogRef.afterClosed().subscribe((result) => {

            if (result == null || result == '' || result == undefined) {

            } else {
                this.http.post<any>(this.ref.baseURL() + 'rejectLoanOffer',
                    {
                        loan_id: this.getLoanId(),
                        profile_id: this.userId,
                        token: this.storageService.getItem(Keys.TOKEN),
                        reject_reason: result
                    }).subscribe((result4) => {
                    if (result4.status == 'success') {
                        this.http.post<any>(this.ref.baseURL() + 'admin/addLog',
                            {
                                profile_id: this.userId,
                                token: this.storageService.getItem(Keys.TOKEN),
                                'loan_id': this.getLoanId(),
                                'verified_by': 'system',
                                'comments': 'loan_rejected',
                                'verified_by_name': 'system',
                                'loan_sanction_status': 'ready_for_kyc',
                                'ipaddress': '',
                                'description': 'loan_rejected',
                                'log_type': 'loan_status',
                                'file_id': '',
                                'status': 'loan_rejected'
                            }).subscribe((result) => {
                            if (result.status == 'success') {
                                this.loanStatus = 'Your loan has been rejected';
                                this.ifNotSanctioned = false;
                                this.ifSanctioned = false;
                                this.ifAccepted = false;
                                this.ifRejected = true;
                            }
                        });
                    } else {

                    }
                });
            }

        });

    }

    private getLoanId() {
        return this.loanId;
    }

    async acceptOffer(event) {
        this.hideRejectBtn = false;
        this.acceptOfferBtn = false;
        if (!this.isEmailVerified) {
            this.openEmailDialog();
        } else {
            await this.acceptLoanOffer();
        }
    }

    reSendEmail(event) {
        this.resendEmail = false;
        this.resendEmailVerificationResult = this.http.post<any>(this.ref.baseURL() + 'resendEmail',
            {
                user_id: this.getLoanId(),
                profile_id: this.userId,
                token: this.storageService.getItem(Keys.TOKEN),
                user_type: 'borrower'
            }).subscribe((result4) => {
            this.resendEmailVerificationResult = result4;
            if (this.resendEmailVerificationResult.status == 'success') {
                this.resendEmail = true;
            } else {

            }
        });
    }

    async ngOnInit() {

        this.isReferralSchemeEnabled = ApiServiceService.isReferralSchemeEnabled();

        const loanId = this.getLoanId();

        const loanDetailsResponse = await this.loanDetailsService.getLoanDetails(loanId);
        const partnerName = loanDetailsResponse.loan_info.partner;

        if (loanDetailsResponse.loan_info.partner !== 'finzy') {
            const partnerDetails = await this.channelPartnerService.getPartnerByName(partnerName);
            this.channelPartner = partnerDetails;
            if (!!partnerDetails && (partnerDetails.disbursalPreference !== 'borrower' || partnerDetails.disbursalPreference === undefined)) {
                this.finzyDomain = false;
                this.otherDomain = true;
                this.partnerName = partnerName;
            } else {
                this.finzyDomain = true;
                this.otherDomain = false;
            }
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
        await this.setLoanDetailsDisplayStatus();

        const loanDetails = loanDetailsResponse.loan_info;
        this.name = loanDetails.profile.name;
        this.email = loanDetails.profile.email;
        this.isEmailVerified = loanDetails.profile.email_verified;
        if (loanDetails.document_upload.length > 0) {
            for (let i = 0; i < loanDetails.document_upload.length; i++) {
                if (loanDetails.document_upload[i].type == 'photo') {
                    this.photo = loanDetails.document_upload[i].source;
                }
            }
        } else {
            this.photo = 'https://res.cloudinary.com/finzy/image/upload/v1490882659/default-user-icon-profile_qjsn3w.png';
        }

        let roi: number;
        let emiAmount: number;

        if (loanDetails.loan_sanction_status == 'pending' || loanDetails.loan_sanction_status == 'ready_for_kyc' || loanDetails.loan_sanction_status == 'kyc_in_progress' || loanDetails.loan_sanction_status == 'ready_for_pcd' || loanDetails.loan_sanction_status == 'pcd_in_progress' || loanDetails.loan_sanction_status == 'ready_for_dcd' || loanDetails.loan_sanction_status == 'dcd_in_progress') {
            this.loanStatus = 'Thank you for submitting your application!';
            this.ifNotSanctioned = true;
            this.ifSanctioned = false;
            this.ifAccepted = false;
            this.ifRejected = false;
        } else if (loanDetails.loan_sanction_status == 'sanctioned') {
            this.offerTime = loanDetails.updatedAt;
            this.offerTime = new Date(new Date(this.offerTime).getTime() + (5 * 24 * 60 * 60 * 1000));
            this.loanAmt = loanDetails.loan_amount;
            emiAmount = Math.round(loanDetails.emi_amount);
            roi = loanDetails.roi;
            this.loan_tenure = loanDetails.loan_tenure;
            this.loanStatus = 'Congrats! Your loan for ₹ ' + this.loanAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' has been sanctioned';
            this.ifNotSanctioned = false;
            this.ifSanctioned = true;
            this.ifAccepted = false;
            this.ifRejected = false;
        } else if (loanDetails.loan_sanction_status == 'accepted') {
            this.loanAmt = loanDetails.loan_amount;
            emiAmount = Math.round(loanDetails.emi_amount);
            roi = loanDetails.roi;
            this.loan_tenure = loanDetails.loan_tenure;
            this.loanStatus = 'Congrats! Your loan for ₹ ' + this.loanAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' has been sanctioned';
            this.ifNotSanctioned = false;
            this.ifSanctioned = true;
            this.ifAccepted = false;
            this.ifRejected = false;
            this.router.navigate(['/loanprogress']);
        } else if (loanDetails.loan_sanction_status == 'rejected') {
            this.loanStatus = 'Your loan has been rejected';
            this.ifNotSanctioned = false;
            this.ifSanctioned = false;
            this.ifAccepted = false;
            this.ifRejected = true;
        } else if (loanDetails.loan_sanction_status == 'closed') {
            this.loanStatus = 'Your loan has been closed';
            this.ifNotSanctioned = false;
            this.ifSanctioned = false;
            this.ifAccepted = false;
            this.ifRejected = true;
        } else if (loanDetails.loan_sanction_status == 'closed_prepayment') {
            this.loanStatus = 'Your loan has been closed';
            this.ifNotSanctioned = false;
            this.ifSanctioned = false;
            this.ifAccepted = false;
            this.ifRejected = true;
        } else if (loanDetails.loan_sanction_status == 'bank_details_filled' ||
            loanDetails.loan_sanction_status == 'loan_disbursed' ||
            loanDetails.loan_sanction_status == 'loan_fulfilled' ||
            loanDetails.loan_sanction_status == 'document_hardcopy_recieved' ||
            loanDetails.loan_sanction_status == 'document_verified' ||
            loanDetails.loan_sanction_status == 'ready_for_disbursal' ||
            loanDetails.loan_sanction_status == 'loan_disbursed_initiated' ||
            loanDetails.loan_sanction_status == 'queued_to_be_fulfilled') {
            this.router.navigate(['/loanprogress']);
        }

        const isSubvented = await this.subventionUtil.isSubvented(loanId);

        if (isSubvented) {
            const result = await this.subventionUtil.getEffectiveRoiAndEffectiveEmiForSubventedLoan(loanDetails);
            this.roi = MathUtil.roundOff(result.roi);
            this.emi_amount = MathUtil.roundOff(result.emi);
        } else {
            this.roi = roi;
            this.emi_amount = emiAmount;
        }
    }

    async breadcrumb(): Promise<string> {
        const applicationId = this.activatedRoute.snapshot.params.applicationId;
        return (await this.loanDetailsService.getLoanDetailsByApplicationId(applicationId)).generated_loan_id;
    }

    public async openEmailDialog(): Promise<void> {
        const response = await this.dialog.open(EmailVerificationModalComponent,
            {
                data: {title: 'Please verify you email to accept the loan'},
                width: '50vw',
                minWidth: '320px'
            }
        ).afterClosed().toPromise();
        if (response) {
            await this.acceptLoanOffer();
        } else {
            this.acceptOfferBtn = true;
            this.hideRejectBtn = true;
        }
    }

    private async setLoanDetailsDisplayStatus(): Promise<void> {
        if (this.channelPartner) {
            const belongsToSubventedPreApproval = await this.channelPartnerService.belongsToPartnerGroupByType(this.channelPartner,
                ChannelPartnerGroupType.SubventedPreApproval);
            if (belongsToSubventedPreApproval) {
                this.hideEmiAmount = true;
                this.hideLoanTenure = true;
            }
        }
    }

    private async acceptLoanOffer() {
        this.loader = true;
        const loanId = this.getLoanId();
        try {
            await this.http.post<any>(this.ref.baseURL() + `loan/${loanId}/accept`, {
                profile_id: this.userId,
                token: this.storageService.getItem(Keys.TOKEN)
            }).toPromise();
            this.loader = false;
            this.acceptOfferBtn = true;
            this.hideRejectBtn = true;
            this.errorEmail = false;
            this.showAcceptBtn = true;
            this.storageService.saveItem(Keys.LOAN_ACCEPTED, 'true');
            this.router.navigate(['/loanprogress']);
        } catch (error) {
            const errorResponse = error as Response;
            if (errorResponse.status === 400) {
                const body = await errorResponse.json();
                if (body.code === 100) {
                    this.loader = false;
                    this.acceptOfferBtn = true;
                    this.hideRejectBtn = true;
                    this.errorEmail = true;
                    this.showAcceptBtn = false;
                    return false;
                }
            }
        }
    }
}
